import store from "app/store/store";
import cloneDeep from "lodash/cloneDeep";
export class OnClickGraphHelper {
  static onClickGraph = (event: Record<string, any>) => {
    // Default details in market data graph are for summary handicap market, home team, full time. If no handicap market, show moneyline market, home team, full time.
    let runnerToDisplay = {};
    let marketToDisplay = {};
    const eventData = cloneDeep(event);
    const handicapRunners =
      eventData &&
      eventData.marketPeriodsSummary &&
      eventData.marketPeriodsSummary[0] &&
      eventData.marketPeriodsSummary[0].marketTypes &&
      eventData.marketPeriodsSummary[0].marketTypes[1] &&
      eventData.marketPeriodsSummary[0].marketTypes[1].markets &&
      eventData.marketPeriodsSummary[0].marketTypes[1].markets[0] &&
      eventData.marketPeriodsSummary[0].marketTypes[1].markets[0].runners &&
      eventData.marketPeriodsSummary[0].marketTypes[1].markets[0].runners;

    if (handicapRunners) {
      marketToDisplay =
        eventData.marketPeriodsSummary[0].marketTypes[1].markets[0];
    }

    runnerToDisplay =
      handicapRunners && handicapRunners.find(runner => runner.side === "HOME");

    if (!handicapRunners) {
      const moneylineRunners =
        eventData &&
        eventData.marketPeriodsSummary &&
        eventData.marketPeriodsSummary[0] &&
        eventData.marketPeriodsSummary[0].marketTypes &&
        eventData.marketPeriodsSummary[0].marketTypes[1] &&
        eventData.marketPeriodsSummary[0].marketTypes[1].markets &&
        eventData.marketPeriodsSummary[0].marketTypes[1].markets[0] &&
        eventData.marketPeriodsSummary[0].marketTypes[1].markets[0].runners &&
        eventData.marketPeriodsSummary[0].marketTypes[1].markets[0].runners;
      runnerToDisplay =
        moneylineRunners &&
        moneylineRunners.find(runner => runner.side === "HOME");

      if (moneylineRunners) {
        marketToDisplay =
          eventData.marketPeriodsSummary[0].marketTypes[0].markets[0];
      }
    }

    store.dispatch.marketDataGraphModel.openMarketGraphModal({
      eventData,
      runnerToDisplay,
      marketToDisplay,
    });
  };
}
